/**
 * formatDuration - человекочитаемая длительность из секунд (RU)
 * ============================================================
 *
 * Примеры:
 *   2    -> "2с"
 *   3162 -> "52м 42с"
 *   9135 -> "2ч 32м 15с"
 *   0    -> "0с"
 *
 * Правила:
 * - секунды округляются до целого перед форматированием;
 * - нулевые единицы опускаются (нет "0ч", "0м"), напр. 3601 -> "1ч 1с";
 * - если всё по нулям — показываем "0с";
 * - единицы: с / м / ч.
 *
 * Чистая функция без зависимостей: используется и виджетом, и тестовым
 * скриптом сервера (npx tsx) — держим её здесь, чтобы не было дублирования.
 */
export function formatDuration(seconds) {
  const total = Math.max(0, Math.round(Number(seconds) || 0));

  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;

  const parts = [];
  if (h > 0) parts.push(`${h}ч`);
  if (m > 0) parts.push(`${m}м`);
  if (s > 0 || parts.length === 0) parts.push(`${s}с`);

  return parts.join(' ');
}

export default formatDuration;
